export const titleClamp = {
    mounted: (el: HTMLElement): void => {
        if (!el.textContent) {
            return;
        }
        el.setAttribute('title', el.textContent);
    }
};